<template>
  <div :id="uppyId">
    <div class="DashboardContainer"></div>
  </div>
</template>

<script>
  import { API } from '../../services/api.ts'
  const Uppy = require('@uppy/core')
  const XHRUpload = require('@uppy/xhr-upload')
  const Dashboard = require('@uppy/dashboard')
  const AwsS3 = require('@uppy/aws-s3')

  export default {
    props: {
      modelClass: {
        type: String,
        required: true
      },
      modelId: {
        type: String,
        required: true
      },
      collection: {
        type: String,
        required: true
      },
      endpoint: {
        type: String,
        required: true,
      },
      path: {
        type: String,
        required: true
      },
      allowedFileTypes: {
        type: Array
      }
    },

    data() {
      return {}
    },

    computed: {
      uppyId() {
        return this.modelClass + '-' + this.modelId + '-' + this.collection;
      }
    },
    methods: {
      createUUID: function() {
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        });
        return uuid;
      }
    },

    mounted() {
      const path = this.path;
      const allowedFileTypes = this.allowedFileTypes;
      const endpoint = this.endpoint;

      const uppy = Uppy({
        id: this.uppyId,
        autoProceed: true,
        debug: true,
        restrictions: {
          maxFileSize: false,
          allowedFileTypes: allowedFileTypes
        },
        meta: {
          modelClass: this.modelClass,
          modelId: this.modelId,
          collection: this.collection
        },
        onBeforeFileAdded: (currentFile, files) => {
          const modifiedFile = Object.assign(
            {},
            currentFile,
            { name: `${this.createUUID()}.${currentFile.name.split('.').pop()}` }
          )
          return modifiedFile
        },
        onBeforeUpload: (files) => {},
      });

      uppy.use(Dashboard, {
        inline: true,
        target: '.DashboardContainer',
        replaceTargetContent: true,
        maxHeight: 500
      })
      .use(
        AwsS3,
        { 
          getUploadParameters(file) {
            return fetch('https://y05tx7o6o2.execute-api.eu-west-1.amazonaws.com/DEV/', {
              method: 'post',
              headers: {
                accept: 'application/json',
                'content-type': 'application/json',
              },
              body: JSON.stringify({
                filename: file.name,
                contentType: file.type,
                path: path,
                publicRead: true,
              }),
            })
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              return {
                method: data.method,
                url: data.url,
                headers: { 'x-amz-acl': 'public-read' },
                fields: {},
              };
            })
            .catch((err) => {
              console.log('error uploading file', err);
            });
          },
        }
      )
      .on("upload-success", function (file) {
        API.post(
          `${endpoint}`,
          {
            originalFilename: file.data.name,
            uniqueFilename: file.name
          }
        ).then(
          response => {
            console.log(response);
          }
        )
      })
    }
  }
</script>

<style src="uppy/dist/uppy.css"></style>